export const AUTH_CREATE_USER = "AUTH_CREATE_USER";
export const AUTH_SIGNIN_USER = "AUTH_SIGNIN_USER";
export const AUTH_LOGOUT_USER = "AUTH_LOGOUT_USER";
export const AUTH_SIGNUP_USER = "AUTH_SIGNUP_USER";
